import styled from 'styled-components';
   
export const Box = styled.div`
  padding: 8px 6px;
  background: black;
  position: absolute;
  bottom: 0;
  width: 100%;
  
   
  @media (max-width: 100%) {
    padding: 70px 30px;
  }
`;
   
export const Container = styled.div`
    display: flex;
    flex-direction: column;
    justify-content: center;
    max-width: 100%;
    margin: 0 auto;
    background: black;
`
   
export const Column = styled.div`
  display: flex;
  flex-direction: column;
  width:65px
  text-align: left;
  margin-left: 6px;
  margin-right:7px;
  background:black;
`;
   
export const Row = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fill, 
                         minmax(185px, 1fr));

  grid-gap: 1px;
  background: black;
  @media (max-width: 100%) {
    grid-template-columns: repeat(auto-fill, 
                           minmax(200px, 1fr));
  }
`;
   
export const FooterLink = styled.a`
  color: #fff;
  display:flex;
  justify-content:space-between;
  align-items:flex-start;
  flex-direction:row;
  flex-wrap:wrap;
  margin-bottom: 5px;
  font-size: 12px;
  font-family:Sans-Serif;
  text-decoration: none;
   
  &:hover {
      color: blue;
      transition: 200ms ease-in;
  }
`;

export const Office = styled.a`
  color: #fff;
  margin-bottom: 5px;
  font-size: 12px;
  font-family:Sans-Serif;
  text-decoration: none;
`;


export const CompanyHighlight = styled.a`
  color: #fff;
  margin-bottom: 5px;
  margin-Left: 15px;
  font-size: 14px;
  font-family:Cursive;
  text-decoration: none;
   
  &:hover {
      color: blue;
      transition: 200ms ease-in;
  }
`;
   
export const Heading = styled.p`
  font-size: 18px;
  font-family:Sans-Serif;
  color: #fff;
  margin-bottom: 15px;
  font-weight: bold;
`;